"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizationController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const localization_service_1 = require("./localization.service");
const response_util_1 = require("../../../../service-lib/src/lib/response.util");
let LocalizationController = class LocalizationController {
    constructor(localizationService) {
        this.localizationService = localizationService;
    }
    async getUserLocalization(req, res) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const localizationData = await this.localizationService.getUserLocalization(userId);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_util_1.createResponse)(common_1.HttpStatus.OK, "Localization retrieved successfully", localizationData));
        }
        catch (error) {
            return res.status(common_1.HttpStatus.NOT_FOUND).json((0, response_util_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error instanceof Error ? error.message : 'Localization not found'));
        }
    }
    async getOrganizationLocalization(req, res, organisation_id) {
        try {
            const localizationData = await this.localizationService.getOrganizationLocalization(organisation_id);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_util_1.createResponse)(common_1.HttpStatus.OK, "Organization localization retrieved successfully", localizationData));
        }
        catch (error) {
            return res.status(common_1.HttpStatus.NOT_FOUND).json((0, response_util_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error instanceof Error ? error.message : 'Organization localization not found'));
        }
    }
};
exports.LocalizationController = LocalizationController;
tslib_1.__decorate([
    (0, common_1.Get)(),
    tslib_1.__param(0, (0, common_1.Req)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_b = typeof Request !== "undefined" && Request) === "function" ? _b : Object, typeof (_c = typeof Response !== "undefined" && Response) === "function" ? _c : Object]),
    tslib_1.__metadata("design:returntype", Promise)
], LocalizationController.prototype, "getUserLocalization", null);
tslib_1.__decorate([
    (0, common_1.Get)('organisation/:organisation_id'),
    tslib_1.__param(0, (0, common_1.Req)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Param)('organisation_id')),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_d = typeof Request !== "undefined" && Request) === "function" ? _d : Object, typeof (_e = typeof Response !== "undefined" && Response) === "function" ? _e : Object, Number]),
    tslib_1.__metadata("design:returntype", Promise)
], LocalizationController.prototype, "getOrganizationLocalization", null);
exports.LocalizationController = LocalizationController = tslib_1.__decorate([
    (0, common_1.Controller)('localization'),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof localization_service_1.LocalizationService !== "undefined" && localization_service_1.LocalizationService) === "function" ? _a : Object])
], LocalizationController);
